import React from 'react';
import '../styles/errorpage.css';
import { useTranslation } from 'react-i18next';

const ErrorPage = () => {

  const { t } = useTranslation('p-errorpage');
  const randomFacts = t('random-facts', { returnObjects: true });

  return (
    <div className="errorpage-body">
      <div className='hero-title'>
        {t('hero-title')}
      </div>
      <div className='hero-description'>
        <p>
          {t('hero-desc')}
        </p>
      </div>
      <div>
        <p>
          {t('body-text-1')}
        </p>
        <p className="random-fact">
          {randomFacts[Math.floor(Math.random() * randomFacts.length)]}
        </p>
        <p>
          {t('body-text-2')}
        </p>
      </div>
    </div>
  );
};

export default ErrorPage;
